<h2 class="default-dialog-header" mat-dialog-title>
	This contact's email was flagged as potentially incorrect. Please confirm you would like to use
	this contact.
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="default-dialog-content">
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-1 m-b-0-5">
		<div fxFlex="40">Carrier Name:</div>
		<div fxFlex="60" fxLayoutAlign="start center">{{ dialogData.carrierName }}</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-0-5 m-b-0-5">
		<div fxFlex="40">MC:</div>
		<div fxFlex="60" fxLayoutAlign="start center">{{ dialogData.mc || '-' }}</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-0-5 m-b-0-5">
		<div fxFlex="40">DOT:</div>
		<div fxFlex="60" fxLayoutAlign="start center">{{ dialogData.dot || '-' }}</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-0-5 m-b-0-5">
		<div fxFlex="40">Contact Name:</div>
		<div fxFlex="60" fxLayoutAlign="start center">
			{{ FULL_NAME(contact?.firstName, contact?.lastName) || '-' }}
		</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-0-5 m-b-0-5">
		<div fxFlex="40">Email:</div>
		<div fxFlex="60" fxLayoutAlign="start center">{{ contact.emailAddress || '-' }}</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-0-5 m-b-0-5">
		<div fxFlex="40">Phone:</div>
		<div fxFlex="60" fxLayoutAlign="start center">
			{{ contact.phone ? (contact.phone | mask : '(000) 000-0000') : '-' }}
		</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-0-5 m-b-1">
		<div fxFlex="40">Mobile:</div>
		<div fxFlex="60" fxLayoutAlign="start center">
			{{ contact.mobile?.length ? (contact.mobile | mask : '(000) 000-0000') : '-' }}
		</div>
	</div>
	<mat-divider></mat-divider>
</mat-dialog-content>
<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button
			(click)="useContact()"
			[disabled]="isRequestInProgress"
			color="primary"
			mat-raised-button
			*ngIf="!isRequestInProgress"
		>
			Yes
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		<span class="link m-l-0-5" (click)="closeDialog()">No</span>
	</div>
</mat-dialog-actions>
